module.exports = __webpack_public_path__ + "static/BT-desktop-19-4cc40addf2fff50e5fca0760f0ff9640.jpg";